import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { CommonService } from '../helpers/common.service';

@Component({
	standalone: false,
  selector: 'no-portfolio-data',
  templateUrl: './no-portfolio-data.component.html',
  styleUrls: ['./no-portfolio-data.component.scss'],
})

export class NoPortfolioDataComponent implements OnInit {
  displayMsg:string = "No Portfolio Data Found";
  constructor(
    private route: ActivatedRoute, private locationSt: LocationStrategy,private commonService: CommonService
  ) {
      // history.pushState(null, null, .location.href);  
      history.pushState(null, '', location.href);  
      this.locationSt.onPopState(() => {
        // history.pushState(null, null, .location.href);
        history.pushState(null, '', location.href);
    });
   }

  ngOnInit() {
    this.commonService.remove('clientLoginId');
    this.commonService.remove('tokenData');

    this.route.queryParams.subscribe((params:any) => {
      console.log(params);
         if(params.Authorization === "N"){
          this.displayMsg = "Invalid Authorization Please login and try again"
         }
    })
  }

}

